import React from 'react';
import { motion } from 'framer-motion';
import MediaCard from './MediaCard';

const MediaGrid = ({ mediaData }) => {
  return (
    <motion.div 
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {mediaData.map((media, index) => (
        <MediaCard key={media.id} media={media} index={index} />
      ))}
      
      {mediaData.length === 0 && (
        <div className="col-span-full text-center py-12">
          <div className="text-gray-500">ไม่พบข้อมูลที่ตรงกับการค้นหา</div>
        </div>
      )}
    </motion.div>
  );
};

export default MediaGrid;